<template>
  <div class="promotion-dialog">
    <div class="promotion-dialog__top">
      <div class="promotion-dialog__top__close-btn" @click="handleClose"></div>
      <div class="promotion-dialog__top__content small">{{ data }}</div>
    </div>
    <div class="promotion-dialog__bottom">
      <a class="button" @click="handleClose" href="javascript:">好的</a>
    </div>
  </div>
</template>

<script>
import mixin from '@/modules/dialog-builder/mixin'

export default {
  name: 'promotion-dialog',
  mixins: [mixin],
  methods: {
    handleClose() {
      this.resolve()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/entry';
.small {
  font-size: 14px;
}
@include b(promotion-dialog) {
  position: fixed;
  top: 300px;
  left: 50%;
  transform: translateX(-50%);
  width: 466px;
  border-radius: 2px;
  overflow: hidden;
  background: #ffffff;
  @include e(top) {
    position: relative;
    @include e(content) {
      padding-top: 96px;
      text-align: center;
      font-size: 16px;
      color: #333333;
    }
    @include e(close-btn) {
      width: 14px;
      height: 14px;
      position: absolute;
      top: 20px;
      right: 20px;
      background-image: url('../assets/img/close-btn-gray.png');
      background-size: cover;
      background-repeat: no-repeat;
      cursor: pointer;
    }
    @include e(bg) {
      width: 286px;
      height: 100%;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      background-size: 286px 82px;
      background-repeat: no-repeat;
      background-position: center bottom;
    }
  }
  @include e(bottom) {
    padding-top: 62px;
    padding-bottom: 32px;
    position: relative;
    .button {
      width: 130px;
      height: 40px;
      display: block;
      margin: 0 auto;
      color: #fff;
      font-size: 16px;
      line-height: 40px;
      text-align: center;
      background: #f13232;
      border-radius: 2px;
      cursor: pointer;
    }
    .des {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 25px;
      text-align: center;
      font-size: 10px;
      color: #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/ConfirmDialog.vue